export enum BillingCodeEditMode {
	DIRECT_EDIT = 'DIRECT_EDIT',
	ARCHIVE_AND_EDIT = 'ARCHIVE_AND_EDIT',
}
